import styled, { keyframes } from 'styled-components';
import { PRIMARY } from '../../styles/colors';

// Spinning animation
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Container = (styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 0;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Spinner = (styled.div<{ $size: number }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top-color: ${PRIMARY};
  border-radius: 50%;
  animation: ${rotate} 0.8s linear infinite;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
